import { create } from 'zustand';

import type { PhoneData } from '../types';

interface UsePhones {
  isLoading: boolean;
  phones: PhoneData[];

  setLoading: (loading: boolean) => void;
  setPhones: (phones: PhoneData[]) => void;
}

export const usePhones = create<UsePhones>(set => ({
  isLoading: false,
  phones: [],

  setLoading: loading => set({ isLoading: loading }),
  setPhones: phones => set({ phones }),
}));
